import { SvgIconProps } from './icon-props';

export function ChevronBoldLeft({ height = 15, width = 9, fill = 'none', role }: SvgIconProps) {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 21 20"
			fill={fill}
			role={role}
			xmlns="http://www.w3.org/2000/svg"
		>
			<g id="icons/navigation&#38;actions/arrow/chevron_bold">
				<path
					id="Mask"
					fillRule="evenodd"
					clipRule="evenodd"
					d="M15.5 20L5.5 10L15.5 0V2L7.5 10L15.5 18V20Z"
					fill="#030303"
				/>
			</g>
		</svg>
	);
}
